import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';

@Directive({ selector: '[boxChild]' })
export class BoxChildDirective {

    constructor(private el: ElementRef, private renderer: Renderer2) { }

    @HostListener('mouseenter', ['$event'])
    onMauseFocus() {
        for (const child of this.el.nativeElement.children) {
            const className = child.className as string;
            if (className.includes('box__warehouse-back') || className.includes('box__warehouse-left') || className.includes('box__warehouse-right')) {
                this.renderer.addClass(child, 'box-warehouse--focus-side');
            }
            else {
                this.renderer.addClass(child, 'box-warehouse--focus');
            }
        }
    }

    @HostListener('mouseleave', ['$event'])
    onMauseLeave() {
        for (const child of this.el.nativeElement.children) {
            this.renderer.removeClass(child, 'box-warehouse--focus');
            this.renderer.removeClass(child, 'box-warehouse--focus-side');
        }
    }
}


/* <div class="box__warehouse" boxChild>
    <div class="box__warehouse-front box-warehouse--focus"></div>
    <div class="box__warehouse-back box-warehouse--focus-side"></div>
    <div class="box__warehouse-left box-warehouse--focus-side"></div>
    <div class="box__warehouse-right box-warehouse--focus"></div>
    <div class="box__warehouse-top box-warehouse--focus"></div>
    <div class="box__warehouse-bottom box-warehouse--focus"></div>
</div> */